'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Iron = function (_React$Component) {
    _inherits(Iron, _React$Component);

    function Iron() {
        _classCallCheck(this, Iron);

        return _possibleConstructorReturn(this, (Iron.__proto__ || Object.getPrototypeOf(Iron)).apply(this, arguments));
    }

    _createClass(Iron, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M25.103 7.639c-0.349-0.175-0.774-0.033-0.949 0.316l-1.219 2.438h-8.835c-4.583 0-8.703 2.546-10.753 6.646l-3.237 6.475c-0.11 0.219-0.098 0.479 0.031 0.688s0.357 0.335 0.602 0.335h18.387c0.391 0 0.707-0.317 0.707-0.707v-2.39c1.538-0.748 3.239-1.146 4.95-1.146 0.208 0 0.405-0.091 0.54-0.25s0.192-0.368 0.158-0.573l-1.376-8.259 1.311-2.623c0.175-0.349 0.033-0.774-0.316-0.949zM18.422 23.122h-16.535l0.707-1.414h15.828v1.414zM18.955 20.293h-15.654l1.311-2.623c1.808-3.617 5.444-5.864 9.488-5.864h8.673l1.183 7.099c-1.739 0.115-3.451 0.588-5.001 1.387z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M17.715 13.221h-4.243c-1.17 0-2.122 0.952-2.122 2.122s0.952 2.122 2.122 2.122h4.243c1.17 0 2.122-0.952 2.122-2.122s-0.952-2.122-2.122-2.122zM17.715 16.050h-4.243c-0.39 0-0.707-0.317-0.707-0.707s0.317-0.707 0.707-0.707h4.243c0.39 0 0.707 0.317 0.707 0.707s-0.317 0.707-0.707 0.707z' })
            );
        }
    }]);

    return Iron;
}(_react2.default.Component);

Iron.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Iron;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/iron.js
// module id = 1106
// module chunks = 0